import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { CellContext } from '@tanstack/react-table';

export interface NetworkListNameCellProps
  extends CellContext<GatewayNetworkModel, GatewayNetworkModel['name']> {}

export const NetworkListNameCell = (
  props: NetworkListNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
